import React, { Component } from 'react';

import ParadigmaTable from '../../components/ParadigmaTable';
import ModalLotes from './ModalLotes';
import api from '../../api/api';

class TableLotes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Descripción",
                    id: "descripcion",
                    accessor: d => d.descripcion,
                    show: true,
                },
                {
                    Header: "Manzana",
                    id: "manzana",
                    accessor: "manzana",
                    className: "text-center",
                    width: 100,
                    show: true,
                },
                {
                    Header: "Número",
                    id: "numero",
                    accessor: "numero",
                    className: "text-center",
                    width: 100,
                    show: true,
                },
                {
                    Header: "Estado",
                    id: "vendido",
                    accessor: d => d.vendido ?
                    <div className="btn-warning text-center">Vendido</div> :
                    <div className="btn-success text-center">Disponible</div>,
                    width: 100,
                    show: true,
                    lookup: 'exact',
                    Filter: ({ filter, onChange }) =>
                        <select
                            value={filter ? filter.value : ''}
                            onChange={e => onChange(e.target.value)}
                        >
                            <option value="">Todos</option>
                            <option value="1">Vendido</option>
                            <option value="0">Disponible</option>
                        </select>,
                }
            ]
        }
    }

    render() {
        const loteoId = this.props.id();
        return (
            <ParadigmaTable
                buttons={[
                    {
                        detail: true,
                        component: props => <ModalLotes {...props} action="DETAIL" loteoId={loteoId} />,
                        permission: 'loteos_detail',
                    },
                    {
                        edit: true,
                        component: props => <ModalLotes {...props} action="EDIT" loteoId={loteoId} />,
                        permission: 'loteos_edit',
                    }
                ]}
                defaultPageSize={15}
                depth={1}
                apiUrl={api.loteos.lotes.replace('$id', loteoId)}
                columns={this.state.columns}
                exportUrl={api.loteos.lotes}
                title={"Lotes"}
            />
        );
    }
}

export default TableLotes;



// WEBPACK FOOTER //
// ./src/views/Loteos/TableLotes.js